<!-- zhangziao -->
<template>
    <div class="w100">
        <article class="wContent center" style="padding: 10px 0 0px 0">
            <el-row :gutter="20">
                <el-col :span="16">
                    <div class="grid-content">
                        <div v-if="adIDsIndex[0] && adIDsIndex[0]['list']" style="margin-bottom: 20px;">
                            <a v-for="(item, index) in adIDsIndex[0]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block">
                                <img :src="item.adPicturePath" alt="" class="w100">
                            </a>
                        </div>
						<el-row class="tac">
						    <el-col :span="6">
						        <!-- <h3>唐宋指数</h3> -->
								<el-menu default-active="1" class="el-menu-vertical-demo" @open="handleOpen" @close="handleClose" @select="handleSelect">
								    <el-submenu index="pricnonobitcchnokrts,pricnonobitcchnokrtste,pricnonobitcchnokrjy">
										<template slot="title">
										  <span>唐宋钢坯价格指数</span>
										</template>
										<el-menu-item-group>
										  <el-menu-item index="pricnonobitcchnokrts">唐宋钢坯价格指数</el-menu-item>
										  <el-menu-item index="pricnonobitcchnokrtste">唐宋唐山钢坯现货指数</el-menu-item>
										  <el-menu-item index="pricnonobitcchnokrjy">唐宋江阴钢坯现货指数</el-menu-item>
										</el-menu-item-group>
								    </el-submenu>
									<el-menu-item index="pricnonohstcchnokrts">
									    <span slot="title">唐宋带钢价格指数</span>
									</el-menu-item>
									<el-submenu index="8FAE2F67663E8E5C810E575903511CC1,B600B408E4335DF4DD50712922EE0A10,FA7A861948BA6BA8E8AA364B1CDB069E">
										<template slot="title">
										  <span>唐宋进口矿价格指数</span>
										</template>
										<el-menu-item-group>
										  <el-menu-item index="8FAE2F67663E8E5C810E575903511CC1">58%粉矿</el-menu-item>
										  <el-menu-item index="FA7A861948BA6BA8E8AA364B1CDB069E">62%粉矿</el-menu-item>
										  <el-menu-item index="B600B408E4335DF4DD50712922EE0A10">65%粉矿</el-menu-item>
										</el-menu-item-group>
									</el-submenu>
									<el-menu-item index="pricnonocoyjchzbkrtsnoo">
									    <span slot="title">唐宋焦炭价格指数</span>
									</el-menu-item>
									<el-submenu index="050C485EB7054E8DA84D8B89C69381FA,C8F123FC68DCFD08D853DF31E92A1069,E01DABAC04001D9D366B2CACD6EBF3BE,CFD649923841F6043E3D6C50EB15BD99">
										<template slot="title">
										  <span>晋南钢铁价格</span>
										</template>
										<el-menu-item-group>
										  <el-menu-item index="050C485EB7054E8DA84D8B89C69381FA" style="line-height: 25px !important;">工字钢
										  <br/>Q235 18#
										  </el-menu-item>
										  <el-menu-item index="C8F123FC68DCFD08D853DF31E92A1069">高线 HPB235 φ8-10</el-menu-item>
										  <el-menu-item index="E01DABAC04001D9D366B2CACD6EBF3BE" style="line-height: 25px !important;">角钢
										  <br/>Q235 10#
										  </el-menu-item>
										  <el-menu-item index="CFD649923841F6043E3D6C50EB15BD99">盘螺 HRB400E φ8-10</el-menu-item>
										</el-menu-item-group>
									</el-submenu>
								</el-menu>
						    </el-col>
							<el-col :span="18">
								<div class="part p20 bgWhite" id="GP" v-show="gp_show">
									<div class="grid-content">
										<div ref="lineChartGP" style="height: 280px;width: 100%;" class="w100"></div>
									</div>
									<div class="grid-content">
										<div class="mw-table-grid p10" style="background-color: #fcfcfc;">
											<div class="mw-table-row bgTransparent">
												<div class="left-table-frow textLeft"><span class="inlineBlock vMid"></span> 指数</div>
												<div>当期值</div>
												<div>涨跌值</div>
												<div>涨跌幅</div>
												<div style="flex: 2">日期</div>
											</div>
											<div class="mw-table-row bgWhite" v-for="(item, index) in priceIndexGP_list_temp" :key="index" style="cursor: pointer;">
												<div>{{ item.nodeName ? item.nodeName : '钢坯' }}</div>
												<div>{{ parseInt(item.data) }}</div>
												<div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ parseInt(item.chg) }}</div>
												<div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ item.range }}%</div>
												<div style="flex: 2">{{ item.rq }}</div>
											</div>
										</div>
									</div>
									<div class="grid-content" v-show="gp_ls_show">
										<div style="font-size: 12px;margin-top: 20px;">
											<el-form :inline="true" class="demo-form-inline" size="small">
												<el-form-item>
													<el-date-picker v-model="begin_end1" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd"></el-date-picker>
												</el-form-item>
												<el-form-item>
													<el-button type="primary" @click="gethistorydata1()" icon="el-icon-search">查询</el-button>
												</el-form-item>
											</el-form>
											<el-table :data="priceIndexGP_history_list">
												<el-table-column property="data" label="当期值"></el-table-column>
												<el-table-column property="chg" label="涨跌值"></el-table-column>
												<el-table-column property="range" label="涨跌幅"></el-table-column>
												<el-table-column property="rq" label="日期"></el-table-column>
											</el-table>
										</div>
									</div>
								</div>
								<div v-if="adIDsIndex[4] && adIDsIndex[4]['list']" v-show="gp_show">
									<a v-for="(item, index) in adIDsIndex[4]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block">
										<img :src="item.adPicturePath" alt="" class="w100">
									</a>
								</div>
								<div class="part p20 bgWhite" id="DG" v-show="dg_show">
									<div class="grid-content">
										<div ref="lineChartDG" style="height: 280px;" class="w100"></div>
									</div>
									<div class="grid-content">
										<div class="mw-table-grid p10" style="background-color: #fcfcfc;">
											<div class="mw-table-row bgTransparent">
												<div class="left-table-frow textLeft"><span class="inlineBlock vMid"></span> 指数</div>
												<div>当期值</div>
												<div>涨跌值</div>
												<div>涨跌幅</div>
												<div style="flex: 2">日期</div>
											</div>
											<div class="mw-table-row bgWhite" v-for="(item, index) in priceIndexDG_list_temp" :key="index" @click="gethistorydata2(item.nCode)" style="cursor: pointer;">
												<div>{{ item.nodeName ? item.nodeName : '带钢' }}</div>
												<div>{{ parseInt(item.data) }}</div>
												<div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ parseInt(item.chg) }}</div>
												<div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ item.range }}%</div>
												<div style="flex: 2">{{ item.rq }}</div>
											</div>
										</div>
									</div>
									<div class="grid-content" v-show="dg_ls_show">
										<div style="font-size: 12px;margin-top: 20px;">
											<el-form :inline="true" class="demo-form-inline" size="small">
												<el-form-item>
													<el-date-picker v-model="begin_end2" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd"></el-date-picker>
												</el-form-item>
												<el-form-item>
													<el-button type="primary" @click="gethistorydata2()" icon="el-icon-search">查询</el-button>
												</el-form-item>
											</el-form>
											<el-table :data="priceIndexDG_history_list">
												<el-table-column property="data" label="当期值"></el-table-column>
												<el-table-column property="chg" label="涨跌值"></el-table-column>
												<el-table-column property="range" label="涨跌幅"></el-table-column>
												<el-table-column property="rq" label="日期"></el-table-column>
											</el-table>
										</div>
									</div>
								</div>
								<div class="part p20 bgWhite" id="JKK" v-show="jkk_show">
									<div class="grid-content">
										<div ref="lineChartJKK" style="height: 280px;" class="w100"></div>
									</div>
									<div class="grid-content">
										<div class="mw-table-grid p10" style="background-color: #fcfcfc;">
											<div class="mw-table-row bgTransparent">
												<div class="left-table-frow textLeft"><span class="inlineBlock vMid"></span> 指数</div>
												<div>当期值</div>
												<div>涨跌值</div>
												<div>涨跌幅</div>
												<div style="flex: 2">日期</div>
											</div>
											<div class="mw-table-row bgWhite" v-for="(item, index) in priceIndexJKK_list_temp" :key="index" @click="gethistorydata3(item.nCode)" style="cursor: pointer;">
												<div>{{ item.nodeName ? item.nodeName : '进口矿' }}</div>
												<div>{{ parseInt(item.data) }}</div>
												<div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ parseInt(item.chg) }}</div>
												<div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ item.range }}%</div>
												<div style="flex: 2">{{ item.rq }}</div>
											</div>
										</div>
									</div>
									<div class="grid-content" v-show="jkk_ls_show">
										<div style="font-size: 12px;margin-top: 20px;">
											<el-form :inline="true" class="demo-form-inline" size="small">
												<el-form-item>
													<el-date-picker v-model="begin_end3" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd"></el-date-picker>
												</el-form-item>
												<el-form-item>
													<el-button type="primary" @click="gethistorydata3()" icon="el-icon-search">查询</el-button>
												</el-form-item>
											</el-form>
											<el-table :data="priceIndexJKK_history_list">
												<el-table-column property="data" label="当期值"></el-table-column>
												<el-table-column property="chg" label="涨跌值"></el-table-column>
												<el-table-column property="range" label="涨跌幅"></el-table-column>
												<el-table-column property="rq" label="日期"></el-table-column>
											</el-table>
										</div>
									</div>
								</div>
								<div class="part p20 bgWhite" id="JT" v-show="jt_show">
									<div class="grid-content">
										<div ref="lineChartJT" style="height: 280px;" class="w100"></div>
									</div>
									<div class="grid-content">
										<div class="mw-table-grid p10" style="background-color: #fcfcfc;">
											<div class="mw-table-row bgTransparent">
												<div class="left-table-frow textLeft"><span class="inlineBlock vMid"></span> 指数</div>
												<div>当期值</div>
												<div>涨跌值</div>
												<div>涨跌幅</div>
												<div style="flex: 2">日期</div>
											</div>
											<div class="mw-table-row bgWhite" v-for="(item, index) in priceIndexJT_list_temp" :key="index" @click="gethistorydata4(item.nCode)" style="cursor: pointer;">
												<div>{{ item.nodeName ? item.nodeName : '进口矿' }}</div>
												<div>{{ parseInt(item.data) }}</div>
												<div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ parseInt(item.chg) }}</div>
												<div :class="{'fontGreen': item.chg < 0, 'fontRed': item.chg > 0, 'fontNormal': item.chg == 0}">{{ item.range }}%</div>
												<div style="flex: 2">{{ item.rq }}</div>
											</div>
										</div>
									</div>
									<div class="grid-content" v-show="jt_ls_show">
										<div style="font-size: 12px;margin-top: 20px;">
											<el-form :inline="true" class="demo-form-inline" size="small">
												<el-form-item>
													<el-date-picker v-model="begin_end4" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy年MM月dd日" value-format="yyyy-MM-dd"></el-date-picker>
												</el-form-item>
												<el-form-item>
													<el-button type="primary" @click="gethistorydata4()" icon="el-icon-search">查询</el-button>
												</el-form-item>
											</el-form>
											<el-table :data="priceIndexJT_history_list">
												<el-table-column property="data" label="当期值"></el-table-column>
												<el-table-column property="chg" label="涨跌值"></el-table-column>
												<el-table-column property="range" label="涨跌幅"></el-table-column>
												<el-table-column property="rq" label="日期"></el-table-column>
											</el-table>
										</div>
									</div>
								</div>
								<div class="part p20 bgWhite" id="JN" v-show="jn_show">
									<div class="grid-content">
										<div ref="lineChartJN" style="height: 280px;" class="w100"></div>
									</div>
									<div class="grid-content">
										<div class="mw-table-grid p10" style="background-color: #fcfcfc;">
											<div class="mw-table-row bgTransparent">
												<div class="left-table-frow textLeft"><span class="inlineBlock vMid"></span> 规格</div>
												<div>当期值</div>
												<div>涨跌值</div>
												<div>涨跌幅</div>
												<div style="flex: 2">日期</div>
											</div>
											<div class="mw-table-row" v-for="(item, index) in priceIndexJN_list_temp" :key="index" @click="gethistorydata5(item.groupCode)" style="cursor: pointer;">
												<div>{{ item.indexName }}</div>
												<div>{{ parseInt(item.higthPrice) }}</div>
												<div :class="{'fontGreen': item.upDownNum < 0, 'fontRed': item.upDownNum > 0, 'fontNormal': item.upDownNum == 0}">{{ parseInt(item.upDownNum) }}</div>
												<div :class="{'fontGreen': item.upDownNum < 0, 'fontRed': item.upDownNum > 0, 'fontNormal': item.upDownNum == 0}">{{ item.ringNum }}%</div>
												<div style="flex: 2">{{ item.dataDate }}</div>
											</div>
										</div>
									</div>
									<div class="grid-content" v-show="jn_ls_show">
										<div style="font-size: 12px;margin-top: 20px;">
											<el-form :inline="true" class="demo-form-inline" size="small">
												<el-form-item>
													<el-date-picker v-model="begin_end5" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy年MM月" value-format="yyyy-MM"></el-date-picker>
												</el-form-item>
												<el-form-item>
													<el-button type="primary" @click="gethistorydata5()" icon="el-icon-search">查询</el-button>
												</el-form-item>
											</el-form>
											<el-table :data="priceIndexJN_history_list">
												<el-table-column property="higthPrice" label="当期值"></el-table-column>
												<el-table-column property="upDownNum" label="涨跌值"></el-table-column>
												<el-table-column property="ringNum" label="涨跌幅"></el-table-column>
												<el-table-column property="dataDate" label="日期"></el-table-column>
											</el-table>
										</div>
									</div>
								</div>
							</el-col>
						</el-row>
                    </div>
                </el-col>
                <el-col :span="8">
                    <div class="grid-content">
                        <!-- <RecordAnalysis></RecordAnalysis> -->
                        <div class="bgWhite p15" style="padding-bottom: 20px; height: 340px;">
                            <h4 class="fontNormal font16" style="margin-bottom: 10px">指数编制方法和管理办法</h4>
                            <div class="mw-table-line">
                                <div class="mw-table-row pointer" v-for="(item, index) in report_list" :key="index" @click="goReportPage(item.reportId)">
                                    <div>{{ item.reportTitle }}</div>
                                    <div>{{ item.reportDate }}</div>
                                </div>
                                
                            </div>
                        </div>
                        <div v-if="adIDsIndex[3] && adIDsIndex[3]['list']" style="margin-bottom: 20px;">
                            <a v-for="(item, index) in adIDsIndex[3]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block" style="margin-top: 10px; margin-bottom: -10px;">
                                <img :src="item.adPicturePath" alt="" class="w100">
                            </a>
                        </div>
                        <MapControl class="mw-modular-box"></MapControl>
                        <div v-if="adIDsIndex[1] && adIDsIndex[1]['list']">
                            <a v-for="(item, index) in adIDsIndex[1]['list']" :key="index" :href="item.adLink" target="_blank" class="w100 block mw-modular-box">
                                <img :src="item.adPicturePath" alt="" class="w100">
                            </a>
                        </div>
                        <HotRecord :ad="adIDsIndex[2] ? ( adIDsIndex[2]['list'].length > 0 ? adIDsIndex[2]['list'][0]['adPicturePath'] : '') : ''" :link="adIDsIndex[2] ? ( adIDsIndex[2]['list'].length > 0 ? adIDsIndex[2]['list'][0]['adLink'] : '') : ''"></HotRecord>
                         <FastNewsControl class="mw-modular-box"></FastNewsControl>
                         <div class="bgWhite p20 price-index-concat">
                            <h4 class="fontNormal font16">各指数负责人联系电话</h4>
                            <div class="w100 mw-modular-box">
                                <div style="display: flex;">
                                    <div class="font14 fontNormal name">钢坯</div>
                                    <!-- <div class="font14 fontNormal contacts">王霞</div> -->
                                    <div class="textRight font14 fontNormal tel">19133607115</div>
                                </div>
                                <div style="display: flex;">
                                    <div class="font14 fontNormal name">进口矿</div>
                                    <!-- <div class="font14 fontNormal contacts">朱晓琳</div> -->
                                    <div class="textRight font14 fontNormal tel">19133607125</div>
                                </div>
                                <div style="display: flex;">
                                    <div class="font14 fontNormal name">焦炭</div>
                                    <!-- <div class="font14 fontNormal contacts">刘楠</div> -->
                                    <div class="textRight font14 fontNormal tel">19133607116</div>
                                </div>
                                <div style="display: flex;">
                                    <div class="font14 fontNormal name">带钢</div>
                                    <!-- <div class="font14 fontNormal contacts">王兰彩</div> -->
                                    <div class="textRight font14 fontNormal tel">19133607124</div>
                                </div>
                                <div style="display: flex;">
                                    <div class="font14 fontNormal name">晋南钢铁价格</div>
                                    <!-- <div class="font14 fontNormal contacts">陈雪</div> -->
                                    <div class="textRight font14 fontNormal tel">19133607151</div>
                                </div>
                                <div style="display: flex;">
                                    <div class="font14 fontNormal name">投诉电话</div>
                                    <!-- <div class="font14 fontNormal contacts">陈雪</div> -->
                                    <div class="textRight font14 fontNormal tel">19133607151</div>
                                </div>
                            </div>
                         </div>
                    </div>
                </el-col>
            </el-row>
        </article>
        <ConcatsControl></ConcatsControl>
    </div>
</template>
<script>
import $ from 'jquery'
import { LineOption_2 } from '../../assets/js/options'
import { baseUrl, adIDs, getQueryString } from '../../assets/js/common'
import MapControl from '../../templates/mapControl'
import HotRecord from '../../templates/hotRecord'
import RecordAnalysis from '../../templates/recordAnalysis'
import ConcatsControl from '../../templates/concatsControl'
import FastNewsControl from '../../templates/fastNewsControl'
export default {
    name: 'PriceIndex',
    components: { MapControl, HotRecord, RecordAnalysis, ConcatsControl, FastNewsControl },
    data () {
        return {
			currenttab:"pricnonobitcchnokrts,pricnonobitcchnokrtste,pricnonobitcchnokrjy",
			begin_end1:null,
			begin_end2:null,
			begin_end3:null,
			begin_end4:null,
			begin_end5:null,
            location: '',
            adIDsIndex: [],
            priceIndex_list: [],
            priceIndexGP_list: [],
            priceIndexDG_list: [],
            priceIndexJKK_list: [],
            priceIndexJN_list: [],
            priceIndexJT_list: [],
			priceIndexGP_list_temp: [],
			priceIndexDG_list_temp: [],
			priceIndexJKK_list_temp: [],
			priceIndexJN_list_temp: [],
			priceIndexJT_list_temp: [],
			priceIndexGP_history_list: [],
			priceIndexDG_history_list: [],
			priceIndexJKK_history_list: [],
			priceIndexJN_history_list: [],
			priceIndexJT_history_list: [],
			echarts1:null,
			echarts2:null,
			echarts3:null,
			echarts4:null,
			echarts5:null,
			gp_show:true,
			dg_show:false,
			jkk_show:false,
			jn_show:false,
			jt_show:false,
			gp_ls_show:false,
			dg_ls_show:true,
			jkk_ls_show:true,
			jn_ls_show:true,
			jt_ls_show:true,
            beginDate: '',
            endDate: '',
            report_list: [],
            hasReport: false
        }
    },
    mounted () {
			const date = new Date();
			const oneMonthAgo = new Date();
			oneMonthAgo.setDate(oneMonthAgo.getDate() - 30);
			this.beginDate = `${oneMonthAgo.getFullYear()}-${oneMonthAgo.getMonth() + 1 >= 10 ? oneMonthAgo.getMonth() + 1 : ('0' + (oneMonthAgo.getMonth() + 1))}`;
			this.endDate = `${date.getFullYear()}-${date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : ('0' + (date.getMonth() + 1))}`;
			this.beginDate1 = `${oneMonthAgo.getFullYear()}-${oneMonthAgo.getMonth() + 1 >= 10 ? oneMonthAgo.getMonth() + 1 : ('0' + (oneMonthAgo.getMonth() + 1))}-${oneMonthAgo.getDate() >= 10 ? oneMonthAgo.getDate() : ('0' + oneMonthAgo.getDate())}`;
			this.endDate1 = `${date.getFullYear()}-${date.getMonth() + 1 >= 10 ? date.getMonth() + 1 : ('0' + (date.getMonth() + 1))}-${date.getDate() >= 10 ? date.getDate() : ('0' + date.getDate())}`;
			this.begin_end1=[this.beginDate1,this.endDate1];
			this.begin_end2=[this.beginDate1,this.endDate1];
			this.begin_end3=[this.beginDate1,this.endDate1];
			this.begin_end4=[this.beginDate1,this.endDate1];
			this.begin_end5=[this.beginDate1,this.endDate1];
			this.setLocation();
			this.getAdByAdp();
			this.getNewsEveryDay();//钢坯
			this.getIronNewsEveryDay();//进口矿
			this.getPriceIndexListJN();//晋南
			this.getNewsEveryDayDG();//带钢
			this.getIndexDatasDG();//带钢
			this.getCokeNewsEveryDay();//焦炭
			// 初始化内容
			this.findReportSortByUserFormat();
			this.findNaTree();
			//this.gethistorydata1();
		},
    methods: {
		handleEvent(key){
			console.log(key);
			var self=this;
			this.currenttab=key;
			if(key=="pricnonobitcchnokrts,pricnonobitcchnokrtste,pricnonobitcchnokrjy"){
				//钢坯
				this.gp_show=true;
				this.dg_show=false;
				this.jkk_show=false;
				this.jn_show=false;
				this.jt_show=false;
				this.getNewsEveryDay();
				setTimeout(function(){
					self.priceIndexGP_list_temp=self.priceIndexGP_list;
					self.echarts1.resize();
				},1000);
				//this.gethistorydata1();
				this.gp_ls_show=false;
			}
			if(key=="pricnonobitcchnokrts"||key=="pricnonobitcchnokrtste"||key=="pricnonobitcchnokrjy"){
				this.gp_show=true;
				this.dg_show=false;
				this.jkk_show=false;
				this.jn_show=false;
				this.jt_show=false;
				this.getNewsEveryDay();
				setTimeout(function(){
					self.priceIndexGP_list.forEach((item,index)=>{
						if(item.nCode==key){
							self.priceIndexGP_list_temp=[];
							self.priceIndexGP_list_temp.push(item);
						}
					})
					self.echarts1.resize();
				},1000);
				this.gethistorydata1();
				this.gp_ls_show=true;
			}
			if(key=="pricnonohstcchnokrts"){
				//带钢
				this.gp_show=false;
				this.dg_show=true;
				this.jkk_show=false;
				this.jn_show=false;
				this.jt_show=false;
				setTimeout(function(){
					self.echarts2.resize();
				},1000);
				this.gethistorydata2();
			}
			if(key=="8FAE2F67663E8E5C810E575903511CC1,B600B408E4335DF4DD50712922EE0A10,FA7A861948BA6BA8E8AA364B1CDB069E"){
				//进口矿
				this.gp_show=false;
				this.dg_show=false;
				this.jkk_show=true;
				this.jn_show=false;
				this.jt_show=false;
				this.getIronNewsEveryDay();
				setTimeout(function(){
					self.priceIndexJKK_list_temp=self.priceIndexJKK_list;
					self.echarts3.resize();
				},1000);
				//this.gethistorydata3();
				this.jkk_ls_show=false;
			}
			if(key=="8FAE2F67663E8E5C810E575903511CC1"||key=="B600B408E4335DF4DD50712922EE0A10"||key=="FA7A861948BA6BA8E8AA364B1CDB069E"){
				this.gp_show=false;
				this.dg_show=false;
				this.jkk_show=true;
				this.jn_show=false;
				this.jt_show=false;
				this.getIronNewsEveryDay();
				setTimeout(function(){
					self.priceIndexJKK_list.forEach((item,index)=>{
						if(item.nCode==key){
							self.priceIndexJKK_list_temp=[];
							self.priceIndexJKK_list_temp.push(item);
						}
					})
					self.echarts3.resize();
				},1000);
				this.gethistorydata3();
				this.jkk_ls_show=true;
			}
			if(key=="pricnonocoyjchzbkrtsnoo"){
				//焦炭
				this.gp_show=false;
				this.dg_show=false;
				this.jkk_show=false;
				this.jn_show=false;
				this.jt_show=true;
				setTimeout(function(){
					self.echarts4.resize();
				},1000);
				this.gethistorydata4();
			}
			if(key=="050C485EB7054E8DA84D8B89C69381FA,C8F123FC68DCFD08D853DF31E92A1069,E01DABAC04001D9D366B2CACD6EBF3BE,CFD649923841F6043E3D6C50EB15BD99"){
				//晋南
				this.gp_show=false;
				this.dg_show=false;
				this.jkk_show=false;
				this.jn_show=true;
				this.jt_show=false;
				this.jn_ls_show=false;
				this.getPriceIndexListJN();
				//setTimeout(function(){
				//	self.priceIndexJN_list_temp=self.priceIndexJN_list;
				//	self.echarts5.resize();
				//},1000);
				//this.gethistorydata5();
			}
			if(key=="050C485EB7054E8DA84D8B89C69381FA"||key=="C8F123FC68DCFD08D853DF31E92A1069"||key=="E01DABAC04001D9D366B2CACD6EBF3BE"||key=="CFD649923841F6043E3D6C50EB15BD99"){
				this.gp_show=false;
				this.dg_show=false;
				this.jkk_show=false;
				this.jn_show=true;
				this.jt_show=false;
				this.jn_ls_show=true;
				this.getPriceIndexListJN();
				//setTimeout(function(){
				//	self.priceIndexJN_list.forEach((item,index)=>{
				//		if(item.groupCode==key){
				//			self.priceIndexJN_list_temp=[];
				//			self.priceIndexJN_list_temp.push(item);
				//		}
				//	})
				//	self.echarts5.resize();
				//},1000);
				this.gethistorydata5();
			}
		},
		handleSelect(key, keyPath) {
            this.handleEvent(key);
		},
		handleOpen(key, keyPath) {
			this.handleEvent(key);
		},
		handleClose(key, keyPath) {
			this.handleEvent(key);
		},
        //页面操作
        setLocation () {
            let location = getQueryString('location') ? getQueryString('location') : '';
            if (location) {
                $('html, body').animate({scrollTop: $(`#${location}`).offset().top }, {duration: 500,easing: 'swing'});
            }
        },
        // 获取广告信息
        getAdByAdp () {
            const self = this;
            self.adIDsIndex = [{
                name: 'zsleft',
                id: adIDs['zsleft'],
                list: []
            },{
                name: 'indexRight1',
                id: adIDs['indexRight1'],
                list: []
            },{
                name: 'indexRight2',
                id: adIDs['indexRight2'],
                list: []
            },{
                name: 'zsright1',
                id: adIDs['zsright1'],
                list: []
            },{
                name: 'zstonglan2',
                id: adIDs['zstonglan2'],
                list: []
            }];
            self.adIDsIndex.forEach((item, index) => {
                self.$get(`${baseUrl.cyw}/industriaAD/getAdByAdp?adpId=${item.id}`, {}).then(res => {
                    if (res.code == 0) {
                        self.adIDsIndex[index]['list'] = res.data;
                    }
                })
            })
        },
		// 获取钢坯历史数据
		gethistorydata1 () {
		    const self = this;
			var tempitem=[{"nodeId":self.currenttab.split(",")[0]}];
			const params = {"param":tempitem,"beginDate":self.begin_end1[0],"endDate":self.begin_end1[1]}
		    self.$post(`${baseUrl.online}/industria/billetDataN/indexDataCompare`, params).then(res => {
		        if (res.code == 0) {
		            self.priceIndexGP_history_list=res.data[0].data.slice(0,30);
		        } else {
		            self.$message.error(res.message)
		        }
		    })
		},
		// 获取带钢历史数据
		gethistorydata2 () {
		    const self = this;
			var tempitem=[{"nodeId":self.currenttab.split(",")[0]}];
			const params = {"param":tempitem,"beginDate":self.begin_end2[0],"endDate":self.begin_end2[1]}
		    self.$post(`${baseUrl.online}/indexData/indexDataCompare`, params).then(res => {
		        if (res.code == 0) {
		            self.priceIndexDG_history_list=res.data[0].data.slice(0,30);
		        } else {
		            self.$message.error(res.message)
		        }
		    })
		},
		// 获取进口矿历史数据
		gethistorydata3 () {
		    const self = this;
			var tempitem=[{"nodeId":self.currenttab.split(",")[0]}];
			const params = {"param":tempitem,"beginDate":self.begin_end3[0],"endDate":self.begin_end3[1]}
		    self.$post(`${baseUrl.online}/industria/ironOreIndexData/newIndexDataCompare`, params).then(res => {
		        if (res.code == 0) {
		            self.priceIndexJKK_history_list=res.data[0].data.slice(0,30);
		        } else {
		            self.$message.error(res.message)
		        }
		    })
		},
		// 获取焦炭历史数据
		gethistorydata4 () {
		    const self = this;
			var tempitem=[{"nodeId":self.currenttab.split(",")[0]}];
			const params = {"param":tempitem,"beginDate":self.begin_end4[0],"endDate":self.begin_end4[1]}
		    self.$post(`${baseUrl.online}/cokeDataN/indexDataCompare`, params).then(res => {
		        if (res.code == 0) {
		            self.priceIndexJT_history_list=res.data[0].data.slice(0,30);
		        } else {
		            self.$message.error(res.message)
		        }
		    })
		},
		// 获取晋南钢铁历史数据
		gethistorydata5 () {
		    const self = this;
			var tempitem=self.currenttab.split(",")[0];
		    self.$get(`${baseUrl.online}/industria/priceIndex/list?groupCode=${tempitem}&beginDate=${self.begin_end5[0]}&endDate=${self.begin_end5[1]}`, {}).then(res => {
		        if (res.code == 0) {
		            self.priceIndexJN_history_list=res.data.slice(0,30);
		        } else {
		            self.$message.error(res.message)
		        }
		    })
		},
        // 获取每日钢坯最新数据
        getNewsEveryDay () {
            const self = this;
            self.$get(`${baseUrl.online}/industria/billetDataN/indexDatas?cpage=1&pageSize=20&nodeId=0101`, {}).then(res => {
                if (res.code == 0) {
                    self.priceIndexGP_list = res.data;
					self.priceIndexGP_list_temp = res.data;
                    self.getIndexDatas(res.data);
                } else {
                    self.GPIsNone = true;
                    self.$message.error(res.message)
                }
            })
        },
        // 获取唐宋钢坯价格指数
        getIndexDatas (newsData) {
            const self = this;
            const option = new LineOption_2();
			var temparr=self.currenttab.split(",");
			var tempobj=[];
			if(self.currenttab=="pricnonobitcchnokrts,pricnonobitcchnokrtste,pricnonobitcchnokrjy"||self.currenttab=="pricnonobitcchnokrts"||self.currenttab=="pricnonobitcchnokrtste"||self.currenttab=="pricnonobitcchnokrjy"){
				temparr.forEach((item,index)=>{
					tempobj.push({"nodeId":item});
				});
			}else{
				tempobj=[{"nodeId":"pricnonobitcchnokrts"},{"nodeId":"pricnonobitcchnokrtste"},{"nodeId":"pricnonobitcchnokrjy"}];
			}
            const params = {"param":tempobj,"beginDate":self.beginDate1,"endDate":self.endDate1}
            const indexDatasColor = ['#e45d3e', '#d392ce', '#e7b483', '#86e6aa'];
            let min = 0;
            let max = 0;
            let seriesObj = {};
            let lineChart = self.$echarts.init(self.$refs.lineChartGP);
            self.$post(`${baseUrl.online}/industria/billetDataN/indexDataCompare`, params).then(res => {
                if (res.code == 0) {
                    const data = $.extend(true, [], res.data);
                    // self.sortDates(data);
                    var x_val = self.getRQ3(data);
                    data.forEach((item, index) => {
                        var _data = [];
                        _data = self.getYAxis3(x_val, item.data);
                        seriesObj = {
                            type: 'line',
                            name: '',
                            connectNulls: true,
                            smooth: true,
                            smoothMonotone: 'none',
                            lineStyle: {
                                color: ''
                            },
                            data: _data
                        }
                        seriesObj.lineStyle.color = indexDatasColor[index];
                        newsData.forEach((cItem, cIndex) => {
                            if (cItem.nCode == item.nodeId) {
                                if (cItem.nCode == 'pricnonobitcchnokrts') {
                                    seriesObj.name = '唐宋钢坯价格指数'; 
                                } else if (cItem.nCode == 'pricnonobitcchnokrjy') {
                                    seriesObj.name = '唐宋江阴钢坯现货指数'
                                } else if (cItem.nCode == 'pricnonobitcchnokrtste') {
                                    seriesObj.name = '唐宋唐山钢坯现货指数'
                                }
                            }
                        })
                        item.data.forEach((cItem, cIndex) => {
                            cItem.data = cItem.data ? Number(cItem.data).toFixed(2) : '';
                            // seriesObj.data.push(cItem.data)
                            max = cItem.data > max ? cItem.data : max;
                            min = (cItem.data < min ? cItem.data : min);
                            // if (index == 0) {
                            //     option.xAxis.data.push(cItem.rq);
                            // }
                        })
                            // console.log(seriesObj.name, option.xAxis.data)
                        option.series.push(seriesObj);
                    })
                    // console.log(option.series)
                    // option.yAxis.min = min - 100;
                    option.xAxis.data = x_val;
                    option.yAxis.max = Number(max) + 1000;
                    option.grid.top = 60;
                    lineChart.setOption(option,{notMerge:true});
					self.echarts1=lineChart;
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('获取指数错误')
            })
        },
        // 获取带钢最新数据
        getNewsEveryDayDG () {
            const self = this;
            self.$get(`${baseUrl.online}/indexData/indexDatas?cpage=1&pageSize=20&nodeId=0401`, {}).then(res => {
                if (res.code == 0) {
                    self.priceIndexDG_list = res.data;
					self.priceIndexDG_list_temp = res.data;
                } else {
                    self.DGIsNone = true;
                    self.$message.error(res.message)
                }
            })
        },
        // 获取唐宋带钢价格指数
        getIndexDatasDG () {
            const self = this;
            const option = new LineOption_2();
            const params = {
                "param":[{"nodeId":"pricnonohstcchnokrts"}],
                "beginDate":self.beginDate1,
                "endDate":self.endDate1
            }
            const indexDatasColor = ['#e45d3e', '#d392ce', '#e7b483', '#86e6aa'];
            let min = 0;
            let max = 0;
            let seriesObj = {};
            let lineChart = self.$echarts.init(self.$refs.lineChartDG); 
            self.$post(`${baseUrl.online}/indexData/indexDataCompare`, params).then(res => {
                if (res.code == 0) {
                    const data = $.extend(true, [], res.data);
                    self.sortDates(data);
                    data.forEach((item, index) => {
                        // item.data = item.data.reverse();
                        seriesObj = {
                            type: 'line',
                            name: '唐宋带钢价格指数',
                            smooth: true,
                            smoothMonotone: 'none',
                            lineStyle: {
                                color: ''
                            },
                            data: []
                        }
                        seriesObj.lineStyle.color = indexDatasColor[index];
                        item.data.forEach((cItem, cIndex) => {
                            cItem.data = cItem.data ? Number(cItem.data).toFixed(2) : '';
                            seriesObj.data.push(cItem.data)
                            max = cItem.data > max ? cItem.data : max;
                            min = (cItem.data < min ? cItem.data : min);
                            if (index == 0) {
                                option.xAxis.data.push(cItem.rq);
                            }
                        })
                        option.series.push(seriesObj);
                    })
                    // option.yAxis.min = min - 100;
                    option.yAxis.max = Number(max) + 1000;
                    option.grid.top = 60;
                    lineChart.setOption(option,{notMerge:true});
					self.echarts2=lineChart;
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('获取指数错误')
            })
        },
        // 获取进口矿每日最新数据
        getIronNewsEveryDay () {
            const self = this;
            self.$get(`${baseUrl.online}/industria/ironOreIndexData/newIndexDatas?cpage=1&pageSize=20&nodeId=0301`, {}).then(res => {
                if (res.code == 0) {
                    self.priceIndexJKK_list = res.data;
					self.priceIndexJKK_list_temp = res.data;
                    self.getIndexDataCompare(res.data);
                } else {
                    self.JKKIsNone = true;
                    self.$message.error(res.message)
                }
            })
        },
        // 获取唐宋进口矿价格指数
        getIndexDataCompare (newsData) {
            const self = this;
            const option = new LineOption_2();
			var temparr=self.currenttab.split(",");
			var tempobj=[];
			if(self.currenttab=="8FAE2F67663E8E5C810E575903511CC1,B600B408E4335DF4DD50712922EE0A10,FA7A861948BA6BA8E8AA364B1CDB069E"||self.currenttab=="8FAE2F67663E8E5C810E575903511CC1"||self.currenttab=="B600B408E4335DF4DD50712922EE0A10"||self.currenttab=="FA7A861948BA6BA8E8AA364B1CDB069E"){
				temparr.forEach((item,index)=>{
					tempobj.push({"nodeId":item});
				});
			}else{
				tempobj=[{"nodeId":"8FAE2F67663E8E5C810E575903511CC1"},{"nodeId":"B600B408E4335DF4DD50712922EE0A10"},{"nodeId":"FA7A861948BA6BA8E8AA364B1CDB069E"}];
			}
            const params = {"param":tempobj,"beginDate":self.beginDate1,"endDate":self.endDate1}
            const indexDatasColor = ['#e45d3e', '#d392ce', '#e7b483', '#86e6aa'];
            let min = 0;
            let max = 0;
            let seriesObj = {};
            let lineChart = self.$echarts.init(self.$refs.lineChartJKK); 
            self.$post(`${baseUrl.online}/industria/ironOreIndexData/newIndexDataCompare`, params).then(res => {
                if (res.code == 0) {
                    const data = $.extend(true, [], res.data);
                    self.sortDates(data);
                    data.forEach((item, index) => {
                        // item.data = item.data.reverse();
                        seriesObj = {
                            type: 'line',
                            name: '',
                            smooth: true,
                            smoothMonotone: 'none',
                            lineStyle: {
                                color: ''
                            },
                            data: []
                        }
                        seriesObj.lineStyle.color = indexDatasColor[index];
                        newsData.forEach((cItem, cIndex) => {
                            if (cItem.nCode == item.nodeId) {
                                seriesObj.name = cItem.nodeName; 
                            }
                        })
                        item.data.forEach((cItem, cIndex) => {
                            cItem.data = cItem.data ? Number(cItem.data).toFixed(2) : '';
                            
                            seriesObj.data.push(cItem.data)
                            max = cItem.data > max ? cItem.data : max;
                            min = (cItem.data < min ? cItem.data : min);
                            if (index == 0) {
                                option.xAxis.data.push(cItem.rq);
                            }
                        })
                        option.series.push(seriesObj);
                    })
                    option.yAxis.min = min;
                    option.yAxis.max = Number(max) + 1000;
                    option.grid.top = 60;
                    option.grid.left = 15;
                    lineChart.setOption(option,{notMerge:true});
					self.echarts3=lineChart;
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('获取指数错误')
            })
        },
        // 获取焦炭每日最新数据
        getCokeNewsEveryDay () {
            const self = this;
            self.$get(`${baseUrl.online}/cokeDataN/indexDatas?cpage=1&pageSize=20&nodeId=0101`, {}).then(res => {
                if (res.code == 0) {
                    self.priceIndexJT_list = res.data;
					self.priceIndexJT_list_temp = res.data;
                    self.getCokeDataCompare(res.data);
                } else {
                    self.JTIsNone = true;
                    self.$message.error(res.message)
                }
            })
        },
        // 获取唐宋焦炭价格指数
        getCokeDataCompare (newsData) {
            const self = this;
            const option = new LineOption_2();
            // const params = {"param":[{"nodeId":"pricnonoiofrchtakrqd013"},{"nodeId":"pricnonoiofrchtakrqd010"},{"nodeId":"pricnonoiofrchtakrqd009"},{"nodeId":"pricnonoiofrchtakrqd008"}],"beginDate":self.beginDate,"endDate":self.endDate}
            const params = {"param":[{"nodeId":"pricnonocoyjchzbkrtsnoo"}],"beginDate":self.beginDate1,"endDate":self.endDate1}
            const indexDatasColor = ['#e45d3e', '#d392ce', '#e7b483', '#86e6aa'];
            let min = 0;
            let max = 0;
            let seriesObj = {};
            let lineChart = self.$echarts.init(self.$refs.lineChartJT); 
            self.$post(`${baseUrl.online}/cokeDataN/indexDataCompare`, params).then(res => {
                if (res.code == 0) {
                    const data = $.extend(true, [], res.data);
                    self.sortDates(data);
                    data.forEach((item, index) => {
                        // item.data = item.data.reverse();
                        seriesObj = {
                            type: 'line',
                            name: '',
                            smooth: true,
                            smoothMonotone: 'none',
                            lineStyle: {
                                color: ''
                            },
                            data: []
                        }
                        seriesObj.lineStyle.color = indexDatasColor[index];
                        newsData.forEach((cItem, cIndex) => {
                            if (cItem.nCode == item.nodeId) {
                                seriesObj.name = cItem.nodeName; 
                            }
                        })
                        item.data.forEach((cItem, cIndex) => {
                            cItem.data = cItem.data ? Number(cItem.data).toFixed(2) : '';
                            seriesObj.data.push(cItem.data)
                            max = cItem.data > max ? cItem.data : max;
                            min = (cItem.data < min ? cItem.data : min);
                            if (index == 0) {
                                option.xAxis.data.push(cItem.rq);
                            }
                        })
                        option.series.push(seriesObj);
                    })
                    option.yAxis.min = min;
                    option.yAxis.max = Number(max) + 1000;
                    option.grid.top = 60;
                    option.grid.left = 15;
                    lineChart.setOption(option,{notMerge:true});
					self.echarts4=lineChart;
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                // self.$message.error('获取指数错误')
            })
        },
        getYAxis3(xArr, list) {
            var len = xArr.length;
            var yAxis = new Array(len);
            var listLen = list.length;
            for(var i in xArr) {
                for(var j in list) {
                    if(list[j].rq == xArr[i]) {
                        yAxis[i] = list[j].data;
                        break;
                    }
                }
            }
            return yAxis;
        },
        getRQ3(data) {
            var rq = [];
            for(var i in data) {
                for(var j in data[i].data) {
                    rq.push(data[i].data[j].rq);
                }
            }
            rq.sort(function(a, b) {
                return Date.parse(b) - Date.parse(a);
            });
            var r = [];
            for(var i = 0, l = rq.length; i < l; i++) {
                for(var j = i + 1; j < l; j++)
                    if(rq[i] === rq[j]) j = ++i;
                r.push(rq[i]);
            }
            r = r.reverse();
            return r;
        },
        // 排列日期
        sortDates (data) {
            let maxLengthDate = data[0]['data'];
            data.forEach((item, index) => {
                if (item.data.length > 0) {
                    item.data = item.data.reverse();
                    if (index < data.length - 1) {
                        if (maxLengthDate.length < data[index + 1]['data'].length) {
                            maxLengthDate = data[index + 1]['data'];
                        }
                    }
                }
            })
            data.forEach((cItem, cIndex) => {
                if (cItem.data.length > 0) {
                    const itemDate = new Date(cItem.data[0].rq).getTime();
                    let pushDate = [];
                    maxLengthDate.forEach((dItem, dIndex) => {
                        const maxTime = new Date(dItem.rq).getTime();
                        if (itemDate > maxTime) {
                            const param = {
                                chg: null, data: null, dataNId: null, highest: null, lowest: null, nCode: null,
                                nodeName: null, operatorId: null, operatorTime: null, range: null, remark: null, rq: dItem.rq, w: null
                            };
                            pushDate.push(param)
                        }
                    })
                    cItem.data = pushDate.concat(cItem.data)
                }
            })
        },
        // 获取晋南钢铁价格
        getPriceIndexListJN () {
            const self = this;
			self.priceIndexJN_list=[];
			self.priceIndexJN_list_temp=[];
            const option = new LineOption_2();
			var temparr=self.currenttab.split(",");
			if(self.currenttab=="050C485EB7054E8DA84D8B89C69381FA,C8F123FC68DCFD08D853DF31E92A1069,E01DABAC04001D9D366B2CACD6EBF3BE,CFD649923841F6043E3D6C50EB15BD99"||self.currenttab=="050C485EB7054E8DA84D8B89C69381FA"||self.currenttab=="C8F123FC68DCFD08D853DF31E92A1069"||self.currenttab=="E01DABAC04001D9D366B2CACD6EBF3BE"||self.currenttab=="CFD649923841F6043E3D6C50EB15BD99"){
			}else{
				temparr=['050C485EB7054E8DA84D8B89C69381FA','C8F123FC68DCFD08D853DF31E92A1069','E01DABAC04001D9D366B2CACD6EBF3BE','CFD649923841F6043E3D6C50EB15BD99'];
			}
            const priceIndexCode = ['050C485EB7054E8DA84D8B89C69381FA', 'C8F123FC68DCFD08D853DF31E92A1069', 'E01DABAC04001D9D366B2CACD6EBF3BE', ' CFD649923841F6043E3D6C50EB15BD99'];
            const priceIndexColor = ['#e45d3e', '#d392ce', '#e7b483', '#86e6aa', '#2ec7c9'];
            let min = 0;
            let max = 0;
            let seriesObj = {};
            let lineChart = self.$echarts.init(self.$refs.lineChartJN);
            // option.title.text = '晋南钢铁价格指数';
            // let dateObj = self.getLastYears();
            temparr.forEach((item, index) => {
                self.$get(`${baseUrl.online}/industria/priceIndex/list?groupCode=${item}&beginDate=${self.beginDate1}&endDate=${self.endDate1}`, {}).then(res => {
                    if (res.code == 0) {
                        const data = $.extend(true, [], res.data);
                        self.priceIndexJN_list.push(data[0]);
						//self.priceIndexJN_list_temp.push(data[0]);
                        res.data = res.data.reverse();
                        seriesObj = {
                            type: 'line',
                            name: '',
                            smooth: true,
                            smoothMonotone: 'none',
                            lineStyle: {
                                color: ''
                            },
                            data: []
                        }
                        seriesObj.lineStyle.color = priceIndexColor[index];
                        seriesObj.name = res.data[0].indexName; 
                        res.data.forEach((cItem, cIndex) => {
                            seriesObj.data.push(cItem.higthPrice)
                            max = cItem.higthPrice > max ? cItem.higthPrice : max;
                            min = index == 0 ? cItem.higthPrice : (cItem.higthPrice < min ? cItem.higthPrice : min); 
                            if (index == 0) {
                                option.xAxis.data.push(cItem.dataDate);
                            }
                        })
                        option.grid.top = 75;
                        option.series.push(seriesObj);
                        if (option.series.length == temparr.length) {
                            //option.yAxis.min = min - 100;
                            option.yAxis.max = Number(max) + 100;
                            lineChart.setOption(option,{notMerge:true});
							self.echarts5=lineChart;
							if(self.currenttab=="050C485EB7054E8DA84D8B89C69381FA,C8F123FC68DCFD08D853DF31E92A1069,E01DABAC04001D9D366B2CACD6EBF3BE,CFD649923841F6043E3D6C50EB15BD99"){
								self.priceIndexJN_list_temp=self.priceIndexJN_list;
								self.echarts5.resize();
							}
							if(self.currenttab=="050C485EB7054E8DA84D8B89C69381FA"||self.currenttab=="C8F123FC68DCFD08D853DF31E92A1069"||self.currenttab=="E01DABAC04001D9D366B2CACD6EBF3BE"||self.currenttab=="CFD649923841F6043E3D6C50EB15BD99"){
								self.priceIndexJN_list.forEach((item,index)=>{
									if(item.groupCode==self.currenttab){
										self.priceIndexJN_list_temp=[];
										self.priceIndexJN_list_temp.push(item);
									}
								})
								self.echarts5.resize();
							}	
                        }
                    } else {
                        self.$message.error(res.message);
                    }
                }).catch(err => {
                    // self.$message.error('获取指数错误')
                })
            })
        },
        // 获取荣钢消防管指数数据
        getPriceIndexList () {
            const self = this;
            const option = new LineOption_2();
            const priceIndexCode = ['0D80920CA76E2CF8939884A478B2353D', '1106B08859E27769C876C3C98A8B0221', 'A1BE7FEC729F81E986B29C7B9FA573AB'];
            const priceIndexColor = ['#e45d3e', '#d392ce', '#e7b483'];
            let min = 0;
            let max = 0;
            let seriesObj = {};
            let lineChart = self.$echarts.init(self.$refs.lineChart); 
            // option.title.text = '荣钢消防管价格指数';

            // let dateObj = self.getLastYears();
            priceIndexCode.forEach((item, index) => {
                self.$get(`${baseUrl.online}/industria/priceIndex/list?groupCode=${item}&beginDate=${self.beginDate1}&endDate=${self.endDate1}`, {}).then(res => {
                    if (res.code == 0) {
                        const data = $.extend(true, [], res.data);
                        self.priceIndex_list.push(data[0]);
                        res.data = res.data.reverse();
                        seriesObj = {
                            type: 'line',
                            name: '',
                            smooth: true,
                            smoothMonotone: 'none',
                            lineStyle: {
                                color: ''
                            },
                            data: []
                        }
                        seriesObj.lineStyle.color = priceIndexColor[index];
                        seriesObj.name = res.data[0].indexName; 
                        res.data.forEach((cItem, cIndex) => {
                            seriesObj.data.push(cItem.higthPrice)
                            max = cItem.higthPrice > max ? cItem.higthPrice : max;
                            min = index == 0 ? cItem.higthPrice : (cItem.higthPrice < min ? cItem.higthPrice : min); 
                            if (index == 0) {
                                option.xAxis.data.push(cItem.dataDate);
                            }
                        })
                        option.grid.top = 60;
                        option.series.push(seriesObj);
                        if (option.series.length == 3) {
                            option.yAxis.min = min - 100;
                            option.yAxis.max = Number(max) + 100;
                            lineChart.setOption(option,{notMerge:true});
                        }

                    } else {
                        self.$message.error(res.message);
                    }
                }).catch(err => {
                    // self.$message.error('获取指数错误')
                })
            })
        },

        // 取最近一年时间
        getLastYears () {
            let date = new Date().getTime();
            let lastDate = date - (86400000 * 365);
            date = new Date(date);
            lastDate = new Date(lastDate);
            let year = date.getFullYear();
            let month = date.getMonth() + 1;
            month = month < 10 ? '0' + month : month;
            let day = date.getDate();
            day = day < 10 ? '0' + day : day;
            let lastYear = lastDate.getFullYear();
            let lastMonth = lastDate.getMonth() + 1;
            lastMonth = lastMonth < 10 ? '0' + lastMonth : lastMonth;
            let lastDay = lastDate.getDate();
            lastDay = lastDay < 10 ? '0' + lastDay : lastDay;
            return {
                last: `${lastYear}-${lastMonth}-${lastDay}`,
                now: `${year}-${month}-${day}`,
                mLast: `${lastYear}-${lastMonth}`,
                mNow: `${year}-${month}`
            }
        },

/* ***** 获取报告分析 - 唐宋100指数（周）报告  start ****************************** */

        // 获取权限
        findNaTree () {
            const self = this;
            const token_cyw = self.$cookies.get('token_cyw');
            let url = ``;
            if (token_cyw) {
                self.$get(`${baseUrl.business}/api/user/userByToken/${token_cyw}`, {}).then(res_1 => {
                    if (res_1.status == 200) {
                        url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=Y`;
                    } else {
                        url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=N`;
                    }
                    self.$get(url, {}).then(res => {
                        if (res.code == 0) {
                            res.data.forEach((item, index) => {
                                if (item.navigationName == '研报') {
                                    self.hasReport = true;
                                }
                            })
                        } else {
                            self.hasReport = false;
                        }
                    }).catch(err => {})
                })
            } else {
                url = `${baseUrl.cyw}/navigation/findNaTree?visitLimit=N`;
                self.$get(url, {}).then(res => {
                    if (res.code == 0) {
                        self.submenu_list_1 = [];
                        res.data.forEach((item, index) => {
                            if (item.navigationName == '研报') {
                                self.hasReport = true;
                            }
                        })
                    } else {
                        self.hasReport = false;
                    }
                }).catch(err => {
                })
            }
        },

        findReportSortByUserFormat () {
            const self = this;
            self.$get(`${baseUrl.online}/industria/reportSort/findReportSortByUserFormat`, {}).then(res => {
                if(res.code == 0) {
                    res.data.forEach((item, index) => {
                        if (item.sortName == '价格指数报告') {
                            self.searchReport(item.sortId);
                        }
                    })
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到报告分类信息');
            })
        },

        searchReport (reportSort) {
            const self = this;
            self.$post(`${baseUrl.online}/industria/report/searchReport/1/8`, {reportSort: reportSort}).then(res => {
                if (res.code == 0) {
                    self.report_list = res.data;
                } else {
                    self.$message.error(res.message);
                }
            }).catch(err => {
                self.$message.error('未获取到报告分类信息');
            })
        },


/* ***** 获取报告分析 - 唐宋100指数（周）报告  end ******************************** */
        goReportPage (id) {
            if (this.hasReport) {
                this.$router.push(`/home/reportDetail/${id}`)
            } else {
                this.$message({
                    message: '登录即可查看全部研报信息',
                    type: 'warning'
                })
            }
        }

    },
}
</script>

<style scoped>
    @import url('priceIndex.css');
</style>